import React from 'react';
import {useSelector} from 'react-redux';
import {useReducerAsync} from 'use-reducer-async';
import {COUNTRY} from 'front-onceforall-core/dist/utils/country';
import SubcontractorsContainer from './SubcontractorsContainer';
import reducer from './store/reducer';
import getAsyncActionHandlers from './store/asyncActionHandlers';

const pageSize = 10;

const initialState = {
  subcontractors: {
    list: [],
    error: false,
    loading: true,
    totalCount: 0,
    dossierCountry: COUNTRY.FRANCE,
    pageSize
  },
  sentInvitations: {
    list: [],
    error: false,
    loading: true
  }
};
const store = React.createContext(initialState);
export const useSubcontractorsStore = () => React.useContext(store);

function SubcontractorsStore() {
  const {Provider} = store;
  const [organisation, user] = useSelector(globalState => [
    globalState.organisation,
    globalState.user
  ]);
  const params = {
    organisationId: organisation.organisationId,
    userId: user.id,
    pageSize
  };

  const [state, dispatch] = useReducerAsync(
    reducer,
    initialState,
    getAsyncActionHandlers(params)
  );

  return (
    <Provider value={{state, dispatch}}>
      <SubcontractorsContainer/>
    </Provider>
  );
}

export default SubcontractorsStore;
